
















































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

// models
import { AreaForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { AreaService } from '@/services/config'

@Component({
    name: 'FormCreateEditArea',
    components: {
        Input,
        Radio
    },
    mixins: [validationMixin]
})
export default class FormCreateEditArea extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) area!: AreaForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: AreaForm = {
        name: '',
        description: '',
        centro: '',
        is_active: true
    }

    created () {
        if (this.idEdit) {
            this.form = this.area
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                description: { required },
                centro: { required }, // Agregamos validación para el campo "centro"
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await AreaService.update(this.idEdit, this.form)
                } else {
                    await AreaService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    name: '',
                    description: '',
                    centro: '',
                    is_active: true
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
